export const FamilyHearthIllustration = ({ className }: TProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="192"
    height="108"
    fill="none"
    className={className}
    viewBox="0 0 257 144"
  >
    <g filter="url(#a)">
      <path
        fill="#fff"
        d="M131.357 118.713a4.002 4.002 0 0 1-5.386 0l-4.353-3.963C96.595 92.059 80.074 77.045 80.074 58.726c0-15.014 11.759-26.724 26.725-26.724 6.845 0 13.467 2.58 18.551 6.837 1.879 1.574 4.749 1.574 6.628 0 5.084-4.257 11.706-6.837 18.551-6.837 14.966 0 26.725 11.71 26.725 26.724 0 18.319-16.521 33.333-41.545 56.024l-4.352 3.963Z"
      />
      <path
        fill="#71C9C4"
        fillRule="evenodd"
        d="M118.861 57.954a3.921 3.921 0 1 0 0 7.843 3.921 3.921 0 0 0 0-7.843Zm-7.842 3.922a7.842 7.842 0 1 1 14.572 4.03 10.527 10.527 0 0 1 3.073 2.85 10.53 10.53 0 0 1 3.074-2.85 7.842 7.842 0 0 1 6.729-11.872 7.842 7.842 0 0 1 6.611 12.062c.411.303.858.674 1.314 1.124 1.643 1.622 3.345 4.223 3.824 8.142a1.96 1.96 0 1 1-3.892.476c-.36-2.944-1.599-4.754-2.687-5.828a7.786 7.786 0 0 0-1.455-1.138l-.079-.046a7.811 7.811 0 0 1-3.636.892 7.806 7.806 0 0 1-3.728-.942 6.431 6.431 0 0 0-1.51.851 6.674 6.674 0 0 0-2.033 2.534 6.864 6.864 0 0 1 4.33 6.38 6.89 6.89 0 0 1-.266 1.9c.221.122.451.26.687.416 1.571 1.04 3.338 2.846 4.375 5.87A1.961 1.961 0 0 1 136.613 88c-.728-2.122-1.902-3.257-2.83-3.872a5.929 5.929 0 0 0-.654-.376 6.835 6.835 0 0 1-4.465 1.652 6.835 6.835 0 0 1-4.465-1.652c-.199.099-.42.222-.653.376-.928.615-2.102 1.75-2.83 3.872a1.96 1.96 0 1 1-3.709-1.272c1.037-3.024 2.803-4.83 4.375-5.87.236-.156.466-.294.687-.416a6.865 6.865 0 0 1 4.064-8.28 6.684 6.684 0 0 0-2.033-2.533 6.431 6.431 0 0 0-1.51-.852 7.807 7.807 0 0 1-3.729.942 7.804 7.804 0 0 1-3.635-.892l-.079.047a7.786 7.786 0 0 0-1.455 1.137c-1.088 1.074-2.327 2.884-2.687 5.828a1.961 1.961 0 0 1-3.893-.476c.48-3.919 2.182-6.52 3.825-8.142.456-.45.903-.821 1.314-1.124a7.803 7.803 0 0 1-1.232-4.22Zm15.315 18.46a2.926 2.926 0 0 1-.611-1.794 2.941 2.941 0 1 1 .611 1.793Zm12.133-22.382a3.921 3.921 0 1 0 0 7.843 3.921 3.921 0 0 0 0-7.843Z"
        clipRule="evenodd"
      />
      <path
        fill="#526476"
        fillRule="evenodd"
        d="M118.858 54.035a7.842 7.842 0 0 0-6.611 12.063c-.411.303-.858.674-1.314 1.124-1.643 1.622-3.345 4.223-3.825 8.141a1.962 1.962 0 0 0 3.893.477c.36-2.944 1.599-4.754 2.687-5.828a7.794 7.794 0 0 1 1.534-1.184 7.807 7.807 0 0 0 3.636.892 7.808 7.808 0 0 0 3.728-.942 6.437 6.437 0 0 1 1.51.851 6.675 6.675 0 0 1 2.033 2.534c1.136-1.663 2.531-3.406 2.531-3.406a10.523 10.523 0 0 0-3.073-2.85 7.842 7.842 0 0 0-6.729-11.872Zm0 3.921a3.922 3.922 0 1 0 0 7.844 3.922 3.922 0 0 0 0-7.844Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="a"
        width="280"
        height="168.41"
        x="-11.336"
        y="-4"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          radius="4"
          result="effect1_dropShadow_2185_1438"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2185_1438"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2185_1438"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export type TProps = {
  width?: number;
  height?: number;
  className?: string;
};
